import { get } from 'lodash';

export default function getSendingEmployeeName(referral = {}) {
  const sendingEmployeeFirstName = get(referral, 'sending_employee.first_name');
  const sendingEmployeeLastName = get(referral, 'sending_employee.last_name');

  if (sendingEmployeeFirstName && sendingEmployeeLastName) {
    return `${sendingEmployeeFirstName} ${sendingEmployeeLastName}`;
  }
  return get(referral, 'referred_by_group.name', '');
}
